"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NodeLabelRegistry = void 0;
const assignNodeLabels_1 = require("../assignNodeLabels");
/**
 * `assignNodeLabels` for a session seen one node at a time. A collision suffix depends on every
 * node sharing the base label, so nodes get a reference now and their label after `resolve()`.
 * Registration order must be `assignNodeLabels`' order: page state, then rule, then unique.
 */
class NodeLabelRegistry {
    #groups = new Map();
    #labels = null;
    #count = 0;
    #sortKeyEntries = 0;
    get size() {
        return this.#count;
    }
    get sortKeyEntries() {
        return this.#sortKeyEntries;
    }
    register(node) {
        if (this.#labels) {
            throw new Error('A node was registered after resolve()');
        }
        const base = (0, assignNodeLabels_1.baseNodeLabel)(node);
        if (!base) {
            return undefined;
        }
        const ref = this.#count++;
        let group = this.#groups.get(base);
        if (!group) {
            group = { base, members: [], unorderable: false };
            this.#groups.set(base, group);
        }
        group.members.push({ ref, key: (0, assignNodeLabels_1.disambiguationKey)(node) });
        this.#sortKeyEntries++;
        if ((0, assignNodeLabels_1.mobileNodeLacksOrderingKey)(node)) {
            group.unorderable = true;
        }
        return ref;
    }
    resolve() {
        const labels = new Array(this.#count);
        for (const group of this.#groups.values()) {
            if (group.members.length < 2 || group.unorderable) {
                group.members.forEach(m => (labels[m.ref] = group.base));
                continue;
            }
            group.members.sort((a, b) => (0, assignNodeLabels_1.compareDisambiguationKeys)(a.key, b.key));
            group.members.forEach((m, index) => {
                labels[m.ref] = (0, assignNodeLabels_1.disambiguatedLabel)(group.base, group.members.length, index);
            });
        }
        this.#groups.clear();
        this.#labels = labels;
    }
    label(ref) {
        if (!this.#labels) {
            throw new Error(`Node label ${ref} was read before resolve()`);
        }
        return this.#labels[ref];
    }
}
exports.NodeLabelRegistry = NodeLabelRegistry;
//# sourceMappingURL=nodeLabelRegistry.js.map